export default {
      id: "play-button-usage",
      viewBox: "0 0 12 10",
      url: __webpack_public_path__ + "img/icons.svg#play-button",
      toString: function () {
        return this.url;
      }
    }